import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Alert, Checkbox,
  Select,
} from 'antd';
import OfferActions from '@Actions/offerActions';
import SellerActions from '@Actions/sellerActions';
import SelectSeller from '@Components/Common/SelectSeller';
import ProductActions from '@Actions/productActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import imageDefault from '@Images/icons/imageDefault.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;
/**
 * OfferForm component
 *
 * @param file
 */
class OfferForm extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      moq: 0,
      maskAsDefault: true,
      markAsPreferredSupplier: false,
    };
  }

  /**
   *
   */
  componentDidMount() {
    const {
      user, getProducts, isFromVendor, isEditing,
    } = this.props;
    if (isFromVendor && !isEditing) { getProducts('', user?.tenant_info?.tenant_id, null, 30, 1); }
  }

  /**
   *
   * @param {*} props props
   * @param {*} state state
   * @return
   */
  static getDerivedStateFromProps(props, state) {
    if (props.isFromVendor && props.isEditing && !state.isUserReady) {
      return {
        ...state,
        moq: props.selectedOffer?.moq || 0,
        offerPrice: props.selectedOffer?.offer_price,
        sellerId: props.selectedOffer?.tenant_seller_id,
        skuOfferId: props.selectedOffer?.sku_offer_id,
        packagingDetails: [null, 'null'].includes(props.selectedOffer?.packaging_details) ? '' : props.selectedOffer?.packaging_details,
        isUserReady: true,
      };
    }

    if (props.isFromVendor) {
      return { ...state, sellerId: props.selectedSeller?.seller_id };
    }

    if (props.isEditing && !state.isUserReady) {
      return {
        ...state,
        sellerId: props.selectedOffer?.seller_info?.seller_id,
        tenantSellerId: props.selectedOffer?.tenant_seller_id,
        moq: props.selectedOffer?.moq || 0,
        offerPrice: props.selectedOffer?.offer_price,
        packagingDetails: props.selectedOffer?.packaging_details,
        maskAsDefault: props.selectedOffer?.is_default,
        markAsPreferredSupplier: props.selectedOffer?.is_preferred_supplier,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   */
  // componentWillUnmount() {
  //   this.setState({
  //     isUserReady: false,
  //   });
  // }

  /**
   *
   */
  addOffer() {
    const {
      packagingDetails, offerPrice, moq, sellerId, maskAsDefault, markAsPreferredSupplier, skuOfferId,
    } = this.state;
    const {
      createOffer, callback, user, currentLine, isEditing, updateSellerOffers, selectedOffer, selectedTenantsForCurrentVendor, isFromVendor, addProductVendor, product, productSkuId, tenantId,
    } = this.props;

    if (isFromVendor && product && offerPrice) {
      if (isEditing) {
        const payload = [{
          seller_id: sellerId,
          moq: moq || 0,
          offer_price: offerPrice,
          sku_offer_id: skuOfferId,
          packaging_details: [null, 'null'].includes(packagingDetails) ? '' : packagingDetails,
        }];
        updateSellerOffers(payload, () => {
          this.setState({
            formSubmitted: false,
            packagingDetails: '',
            offerPrice: '',
            moq: '',
          });
          callback();
        });
      } else {
        const payload = [{
          tenant_id: user?.tenant_info?.tenant_id,
          product_sku_id: productSkuId,
          seller_id: sellerId,
          moq: moq || 0,
          offer_price: offerPrice,
          mrp: offerPrice,
          is_active: true,
          packaging_details: packagingDetails || '',
        }];
        addProductVendor(payload, 1, '', () => {
          this.setState({
            formSubmitted: false,
            packagingDetails: '',
            offerPrice: '',
            moq: '',
          });
          callback();
        });
      }
    } else if (offerPrice && sellerId) {
      if (isEditing) {
        let payload;

        if (selectedTenantsForCurrentVendor) {
          const fixPayload = {
            sku_offer_id: selectedOffer?.sku_offer_id,
            product_sku_id: currentLine?.productSkuId || currentLine?.product_sku_id,
            seller_id: sellerId,
            is_active: true,
            packaging_details: packagingDetails || '',
            offer_price: offerPrice,
            moq: moq || 0,
            mrp: offerPrice,
            mark_default_offer: maskAsDefault,
            is_preferred_supplier: markAsPreferredSupplier,
          };
          payload = selectedTenantsForCurrentVendor.map((tId) => ({
            ...fixPayload, tenant_id: tId,
          }));
        } else {
          payload = [{
            sku_offer_id: selectedOffer?.sku_offer_id,
            product_sku_id: currentLine?.productSkuId || currentLine?.product_sku_id,
            seller_id: sellerId,
            is_active: true,
            packaging_details: packagingDetails || '',
            offer_price: offerPrice,
            mark_default_offer: maskAsDefault,
            is_preferred_supplier: markAsPreferredSupplier,
            moq: moq || 0,
            mrp: offerPrice,
            tenant_id: tenantId || user?.tenant_info?.tenant_id,
          }];
        }

        updateSellerOffers(payload, () => {
          callback();
          this.setState({
            formSubmitted: false,
            packagingDetails: '',
            offerPrice: '',
            moq: '',
          });
        });
      } else {
        let payload;
        if (selectedTenantsForCurrentVendor) {
          const fixPayload = {
            sku_offer_id: selectedOffer?.sku_offer_id,
            product_sku_id: currentLine?.productSkuId || currentLine?.product_sku_id,
            seller_id: sellerId,
            is_active: true,
            packaging_details: packagingDetails || '',
            offer_price: offerPrice,
            moq: moq || 0,
            mrp: offerPrice,
            mark_default_offer: maskAsDefault,
            is_preferred_supplier: markAsPreferredSupplier,
          };
          payload = selectedTenantsForCurrentVendor.map((tenantId) => ({
            ...fixPayload, tenant_id: tenantId,
          }));
        } else {
          payload = [{
            product_sku_id: currentLine?.productSkuId || currentLine?.product_sku_id,
            seller_id: sellerId,
            is_active: true,
            packaging_details: packagingDetails || '',
            offer_price: offerPrice,
            moq: moq || 0,
            mrp: offerPrice,
            tenant_id: tenantId || user?.tenant_info?.tenant_id,
            mark_default_offer: maskAsDefault,
            is_preferred_supplier: markAsPreferredSupplier,
          }];
        }
        createOffer(payload, () => {
          callback();
          this.setState({
            formSubmitted: false,
            packagingDetails: '',
            offerPrice: '',
            moq: '',
          });
        });
      }
    }
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      sellerId, formSubmitted, moq, offerPrice, packagingDetails, tenantSellerId, maskAsDefault, markAsPreferredSupplier,
    } = this.state;
    const {
      createOfferLoading, updateSellerOffersLoading,
      toggleNewOfferModal, isEditing, tenantId, marketplace, MONEY_SYMBOL, user, isFromVendor, product, productSkuId, setShowNewProductModal, getProducts, setProduct, setProductSkuId, products, addProductVendorLoading, priceMasking,
    } = this.props;

    const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;
    return (
      <Fragment>
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={isFromVendor ? { width: '375px' } : { width: '310px' }}>
            <H3Text text={!isEditing ? 'Add Vendor Price' : 'Update Vendor Price'} className="custom-drawer__title" style={{ width: '640px' }} />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => toggleNewOfferModal()} />
          </div>
        </div>
        {marketplace && (
          <div style={{ marginBottom: '10px' }}>
            <Alert
              message="You can only add a marketplace seller for the vendor offer."
              type="info"
              showIcon
              className=""
            />
          </div>
        )}
        <div className="ant-row">

          <div className="ant-col-md-24">
            {isFromVendor ? (
              <div className="orgInputContainer">
                <div style={{ display: 'flex' }}>
                  <label style={{ width: '82%' }} className="orgFormLabel">
                    {!isEditing ? 'Select Product' : 'Selected Product'}
                    <span style={{ color: 'red' }}>{'  *'}</span>
                  </label>
                  {!isEditing && (
                    <div
                      onClick={() => {
                        setShowNewProductModal(true);
                      }}
                      className="create-product__new-vendor-text"
                    >
                      + Add Product
                    </div>
                  )}
                </div>
                <PRZSelect
                  value={product}
                  showSearch
                  onSearch={(searchKeyword) => {
                    getProducts(searchKeyword, user?.tenant_info?.tenant_id, null, 30, 1);
                  }}
                  onChange={(selectedProduct) => {
                    const copySelectedProduct = JSON.parse(selectedProduct);
                    setProduct(copySelectedProduct.product_info.product_sku_name);
                    setProductSkuId(copySelectedProduct.product_info.product_sku_id);
                  }}
                  disabled={addProductVendorLoading || isEditing}
                  showError={formSubmitted && !product}
                  errorName=" a product"
                  errorClassName="input-error"
                >
                  {products?.result?.products?.filter((item) => (marketplace ? item?.is_marketplace_product : !item?.is_marketplace_product))?.map((item) => (
                    <Option key={item.product_sku_id} value={JSON.stringify(item)}>
                      <div className="product-name__suggestion-item">
                        { item?.product_info?.assets?.[0]?.url
                          ? (
                            <H3Image
                              src={`${item?.product_info?.assets?.[0]?.url}`}
                              style={{ height: '35px', width: '35px' }}
                              className="new-offer__item-image"
                            />
                          )
                          : (
                            <H3Image
                              src={imageDefault}
                              style={{ height: '35px', width: '35px' }}
                              className="prod-table__image__default"
                            />
                          )}
                        <H3Text
                          text={`${item?.product_info?.product_sku_name}`}
                          className="product-name__suggestion-item__text"
                        />
                      </div>
                    </Option>
                  )) }
                </PRZSelect>
              </div>
            ) : (
              <SelectSeller
                marketplace={marketplace}
                onChange={(value) => {
                  this.setState({
                    sellerId: value?.seller_id,
                    tenantSellerId: value?.tenant_seller_id,
                  });
                }}
                selectedSeller={tenantSellerId}
                disabled={createOfferLoading || updateSellerOffersLoading || isEditing}
                containerClass="orgInputContainer "
                inputClassName="create-offer__input-row__input"
                labelClassName="orgFormLabel"
                showError={formSubmitted && !sellerId}
                showAddVendor
                tenantId={tenantId}
                getPopupContainer
                isMarketplaceSeller={marketplace}
              />
            ) }
          </div>

          <div className="ant-col-md-24">
            <H3FormInput
              name="MOQ"
              type="number"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => (event.target.value > 0 ? this.setState({ moq: event.target.value }) : this.setState({ moq: '' }))}
              value={moq}
              label="Minimum Order Quantity"
              maxlength="50"
              disabled={createOfferLoading || updateSellerOffersLoading || addProductVendorLoading}
            />
          </div>
          <div className="ant-col-md-24">
            <H3FormInput
              name={isFromVendor ? 'Price' : 'vendor price'}
              type="number"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => (event.target.value > -1 ? this.setState({ offerPrice: event.target.value }) : this.setState({ offerPrice: '' }))}
              value={offerPrice}
              label={`${isFromVendor ? (isEditing ? 'Offer price' : 'Price') : 'Vendor Price'} (${MONEY_SYMBOL})`}
              maxlength="50"
              required
              disabled={createOfferLoading || updateSellerOffersLoading || addProductVendorLoading}
              showError={formSubmitted && !offerPrice}
              hideInput={isDataMaskingPolicyEnable && isHideCostPrice}
              popOverMessage={"You don't have access to view offer price"}
            />
          </div>
          <div className="ant-col-md-24">
            <H3FormInput
              name="packaging details"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ packagingDetails: event.target.value })}
              value={packagingDetails}
              disabled={createOfferLoading || updateSellerOffersLoading || addProductVendorLoading}
              label="Packaging Details"
              maxlength="50"
            />
          </div>

          {!isFromVendor && user?.tenant_info?.global_config?.settings?.marketplace_enabled && (
            <div className="ant-col-md-24">
              <div className="orgInputContainer product-form__right-input">
                <Checkbox
                  disabled={createOfferLoading || updateSellerOffersLoading}
                  checked={markAsPreferredSupplier}
                  onChange={() => { this.setState({ markAsPreferredSupplier: !markAsPreferredSupplier }); }}
                >
                  <div className="orgFormLabel">Mark as Preferred Supplier</div>
                </Checkbox>
              </div>
            </div>
          )}
          {!isFromVendor && user?.tenant_info?.global_config?.settings?.marketplace_enabled && (
            <div className="ant-col-md-24">
              <div className="orgInputContainer product-form__right-input">
                <Checkbox
                  disabled={createOfferLoading || updateSellerOffersLoading}
                  checked={maskAsDefault}
                  onChange={() => { this.setState({ maskAsDefault: !maskAsDefault }); }}
                >
                  <div className="orgFormLabel">Mark as Default</div>
                </Checkbox>
              </div>
            </div>
          )}

          <div className="ant-col-md-24">
            <H3Button
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              text={isFromVendor ? (isEditing ? 'Update Price' : 'Add offer') : 'Submit'}
              onClick={() => {
                this.setState({ formSubmitted: true });
                if(offerPrice && (isFromVendor ? product : sellerId)) {
                  this.addOffer()
                }
              }}
              disabled={createOfferLoading || updateSellerOffersLoading || addProductVendorLoading}
              isLoading={createOfferLoading || updateSellerOffersLoading || addProductVendorLoading}
              style={{
                width: '200px',
                borderRadius: '5px',
                padding: '7px 0px',
                marginLeft: '0',
              }}
            />
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  OfferReducers, SellerReducers, UserReducers, ProductReducers,
}) => ({
  getOffersLoading: OfferReducers.getOffersLoading,
  offers: OfferReducers.offers,
  createOfferLoading: OfferReducers.createOfferLoading,
  sellers: SellerReducers.sellers,
  updateSellerOffersLoading: SellerReducers.updateSellerOffersLoading,
  user: UserReducers.user,
  MONEY_SYMBOL: UserReducers.MONEY_SYMBOL,
  createSellerLoading: SellerReducers.createSellerLoading,
  addProductToInventoryLoading: ProductReducers.addProductToInventoryLoading,
  products: ProductReducers.products,
  addProductVendorLoading: ProductReducers.addProductVendorLoading,
  priceMasking: UserReducers.priceMasking,
});

const mapDispatchToProps = (dispatch) => ({
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  createOffer: (payload, callback, getOffersAgain, skuId) => dispatch(OfferActions.createOffer(payload, callback, getOffersAgain, skuId)),
  getSellers: (keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType) => dispatch(SellerActions.getSellers(keyword, tenantId, page, limit, sellerId, callback, isActive, isSubcontractor, sellerType)),
  updateSellerOffers: (payload, callback) => dispatch(SellerActions.updateSellerOffers(payload, callback)),
  addProductVendor: (payload, page, keyword, callback) => dispatch(ProductActions.addProductVendor(payload, page, keyword, callback)),
  getProducts: (keyword, tenantId, stockStatus, limit, page) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page)),
  getSellerOffersById: (vendorId, page) => dispatch(SellerActions.getSellerOffersById(vendorId, page)),

});

OfferForm.propTypes = {
  getOffersLoading: PropTypes.bool,
  createOffer: PropTypes.func,
  createOfferLoading: PropTypes.bool,
  getSellers: PropTypes.func,
  user: PropTypes.any,
  isEditing: PropTypes.bool,
  selectedOffer: PropTypes.any,
  callback: PropTypes.func,
  currentLine: PropTypes.any,
  updateSellerOffers: PropTypes.func,
  sellers: PropTypes.any,
  toggleNewOfferModal: PropTypes.func,
  marketplace: PropTypes.bool,
  updateSellerOffersLoading: PropTypes.bool,
  selectedTenantsForCurrentVendor: PropTypes.any,
  addProductVendor: PropTypes.func,
  addProductVendorLoading: PropTypes.bool,
  products: PropTypes.any,
  getProducts: PropTypes.func,
  setShowNewProductModal: PropTypes.func,
  product: PropTypes.any,
  setProduct: PropTypes.func,
  setProductSkuId: PropTypes.func,
  selectedSeller: PropTypes.any,
  productSkuId: PropTypes.any,
  isFromVendor: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OfferForm));
